import React from "react";
import websiteData from '../data.json';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Row, Col } from 'react-bootstrap';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
    ReactGA.initialize('UA-90162173-1');
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

class PrivacyPolicy extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        initGA();
        logPageView();
        window.scrollTo(0, 0);
    }

    render() {
        const firstPart = websiteData.footer.footerPrivacyPolicyContentFirstPart,
            secondPart = websiteData.footer.footerPrivacyPolicyContentSecondPart;
        //console.log(firstPart)
        return (
            <div id="page" className="gtco-container" style={{marginTop: 120}}>
                <div>
                    {this.props.translate(firstPart)}
                </div>
                <div>
                    {this.props.translate(secondPart)}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        translate: getTranslate(state.locale),
        props: ownProps
    };
};

export default connect(mapStateToProps)(PrivacyPolicy);


// WEBPACK FOOTER //
// ./src/pages/privacy-policy-page.js